import { render, staticRenderFns } from "./FiUseCaseDetails.vue?vue&type=template&id=2428f346&scoped=true"
import script from "./FiUseCaseDetails.vue?vue&type=script&lang=js"
export * from "./FiUseCaseDetails.vue?vue&type=script&lang=js"
import style0 from "../scss/infoCards.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./FiUseCaseDetails.vue?vue&type=style&index=1&id=2428f346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2428f346",
  null
  
)

export default component.exports